/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import workspaceCard from 'ui/mixins/cards/workspace-card';
import Dialog from 'shared/ui/components/modals/DialogComponent.vue';

import { mapGetters } from 'vuex';
import { downloadFile } from 'libs/utils/helpers/download';

/**
 * This component renders a connected event card.
 */
const __vue_script__ = {
    name: 'ConnectedEvent',

    mixins: [workspaceCard],

    data() {
        const eventId = this.workspace._id;
        const contentHub = this.$store.state.core.contentHub;
        const isWebinar = contentHub.webinars.includes(eventId);
        const img = isWebinar ? undefined : this.$services.event.getAppIconUrl(this.workspace) || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==';

        return { eventId, img, isWebinar, submitting: false, canSyncUsers: false, canAddRemoveEvents: false };
    },

    computed: {
        ...mapGetters(['contentHub', 'permissionContext'])
    },

    created() {
        this.canSyncUsers = this.$services.user.hasPermission('content_hub.manage_users', this.permissionContext);
        this.canAddRemoveEvents = this.$services.user.hasPermission('content_hub.manage_content', this.permissionContext);
    },

    methods: {
        /**
         * Shows a confirmation dialog for disconnecting an event
         */
        confirmDisconnect() {
            this.$modal.show(Dialog, {
                title: this.$i18n.t('connected_events.disconnect_event'),
                text: `
                    <p>${this.$i18n.t('connected_events.messages.disconnect_p1')}</p>
                    <p>${this.$i18n.t('connected_events.messages.disconnect_p2')}</p>
                    <p>${this.$i18n.t('connected_events.messages.disconnect_p3')}</p>
                `,
                buttons: [{
                    title: this.$i18n.t('general.cancel'),
                    default: true,
                    class: 'btn',
                    closeOnClick: true
                }, {
                    title: this.$i18n.t('connected_events.disconnect_event'),
                    closeOnClick: true,
                    handler: () => this.disconnect(),
                    class: 'btn btn-danger'
                }]
            }, {
                height: 'auto'
            });
        },

        /**
         * Disconnects an event from a content hub
         */
        async disconnect() {
            const propName = this.isWebinar ? 'webinars' : 'workspaces';
            const data = { [propName]: this.contentHub[propName].filter(id => id !== this.eventId) };

            try {
                await this.$services.contentHub.update(this.contentHub.id, data);

                this.$store.dispatch('refresh', { services: this.$services });
            } catch (error) {
                console.error('[ConnectedWebinar] An error occurred while updating content hub');
                this.$services.crashReporting.captureException(error);
            }
        },

        /**
         * Prompts the user for sync confirmation
         *
         * @param {'import'|'sync'} syncType the type of the sync to do
         */
        async promptUser(syncType) {
            this.$modal.show('dialog', {
                title: this.$t(`connected_events.${syncType}_users`),
                text: this.$t(`connected_events.${syncType}_users_confirmation`),
                buttons: [{
                    title: this.$t('general.cancel'),
                    default: true,
                    class: 'btn'
                }, {
                    title: this.$t(`connected_events.${syncType}_users`),
                    handler: async () => {
                        this.syncUsers(syncType);
                        this.$modal.hide('dialog');
                    },
                    class: 'btn btn-primary'
                }]
            });
        },

        /**
         * Synchronise the users of the event
         */
        async syncUsers(syncType) {
            try {
                this.submitting = true;
                const { jobId } = await this.$services.contentHub.syncEventUsers(this.contentHub.id, this.eventId);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(`connected_events.${syncType}_started`),
                    type: 'success',
                    duration: 5000
                });

                await this.checkSyncJobForErrors(jobId, syncType);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(`connected_events.${syncType}_users_success`),
                    type: 'success',
                    duration: 5000
                });
            } catch (error) {
                console.error('[ConnectedEvent] Could not sync users', error.message);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(`connected_events.error.${syncType}_heading`),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.submitting = false;
            }
        },

        /**
         * Wait for the sync job to complete and check for failed sync report
         */
        async checkSyncJobForErrors(jobId, syncType) {
            await this.$services.jobs.waitFor({ jobId });

            const errDocId = `${this.eventId}_${jobId}`;
            let errDoc;
            try {
                errDoc = await this.$services.documents.getDocById(this.contentHub.id, errDocId);
            } catch {
                // Do nothing, we're just trying to fetch the error report (not present if there aren't any errors)
            }
            if (!errDoc) return;

            const downloadUrl = this.$services.contentHub.getDownloadUrl(this.contentHub.id, errDoc._id, 'failed-sync-report.xls');

            this.$notify({
                group: 'flashes',
                title: this.$i18n.t(`connected_events.error.${syncType}_heading`),
                text: this.$i18n.t(`connected_events.error.${syncType}_body`),
                type: 'error',
                duration: -1,
                data: {
                    button: this.$i18n.t('connected_events.error.btn_text'),
                    action: () => downloadFile(downloadUrl)
                }
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspace-card connected-event",class:{ 'connected-webinar': _vm.isWebinar }},[(!_vm.isWebinar)?_c('div',{staticClass:"media"},[_c('i',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.img),expression:"img",arg:"background-image"}],staticClass:"lazy picture"})]):_vm._e(),_c('div',{staticClass:"event-info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('small',{staticClass:"sub"},[_vm._v(_vm._s(_vm.subtitle))])]),_c('div',{staticClass:"stage"},[_c('event-badge',{attrs:{"event":_vm.workspace}})],1),_c('div',{staticClass:"import-status"},[(_vm.workspace.last_users_sync_at)?_c('span',{staticClass:"sync"},[_vm._v(_vm._s(_vm.$t('connected_events.users_synced')))]):_c('span',{staticClass:"sync"},[_vm._v(_vm._s(_vm.$t('connected_events.users_not_sync')))])]),_c('div',{staticClass:"last-sync"},[(_vm.workspace.last_users_sync_at)?_c('small',{staticClass:"sync"},[_vm._v(_vm._s(_vm.$t('connected_events.users_sync_at'))),_c('br'),_vm._v(_vm._s(_vm.$utils.time.tsToFormat(_vm.workspace.last_users_sync_at)))]):_vm._e()]),_c('div',{staticClass:"actions"},[(_vm.canSyncUsers && _vm.workspace.last_users_sync_at)?_c('button',{staticClass:"btn",attrs:{"disabled":_vm.submitting},on:{"click":function($event){return _vm.promptUser('sync')}}},[_c('i',{staticClass:"ic-refresh-cw"}),_vm._v(_vm._s(_vm.$t('connected_events.sync_users')))]):_vm._e(),(_vm.canSyncUsers && !_vm.workspace.last_users_sync_at)?_c('button',{staticClass:"btn",attrs:{"disabled":_vm.submitting},on:{"click":function($event){return _vm.promptUser('import')}}},[_vm._v(_vm._s(_vm.$t('connected_events.import_users')))]):_vm._e(),(_vm.canAddRemoveEvents)?_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('connected_events.disconnect')),expression:"$t('connected_events.disconnect')"}],staticClass:"btn btn-danger btn-icon single",on:{"click":function($event){return _vm.confirmDisconnect()}}},[_c('i',{staticClass:"ic-unlink"})]):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ConnectedEvent.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__